import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { List, Icon, Button, Label, Segment } from 'semantic-ui-react';
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper';

const ListViewer = ({ dataType, data, handleSelect, parentData }) => {

  const [currentData, setCurrentData] = useState(data);
  const [currentKeys, setCurrentKeys] = useState({ header: '', item: '' });
  const [expandedItems, setExpandedItems] = useState({});
  const [isAllExpanded, setIsAllExpanded] = useState(true);

  useEffect(() => {
    if (data) {
      switch (dataType) {
        case 'teams':
          const d = {}
          const gb = _.groupBy(data, 'parentKeys.schools')
          _.forEach(gb, (g, gk) => {
            if (!d[gk]) { d[gk] = { key: gk, name: null, teams: {} } }
            _.forEach(g, (gi, gik) => {
              const { name, _itemKey } = gi
              if (!d[gk].name) { d[gk].name = name }
              d[gk].teams[_itemKey] = gi

            })
          })
          setCurrentKeys({ header: 'schools', item: dataType })
          setCurrentData(d)
          break;
        case '_schools_district':
          setCurrentKeys({ header: dataType, item: 'teams' })
          setCurrentData(data)
          break;
        default:
          setCurrentKeys({ header: dataType, item: dataType })
          setCurrentData(data)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [dataType, data]);

  // Toggle function for a specific item
  const toggleExpand = (key) => {
    setExpandedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Global toggle function for all items
  const toggleAll = () => {
    const newExpandState = !isAllExpanded;
    const updatedExpandedItems = _.reduce(
      currentData,
      (acc, _, key) => ({ ...acc, [key]: newExpandState }),
      {}
    );
    setExpandedItems(updatedExpandedItems);
    setIsAllExpanded(newExpandState);
  };

  const listValue = (value, key, ignoreSc) => {
    if (_.isObject(value)) {
      const _data = sortedData(value)
      const _count = _.size(_data)
      return <Segment style={{ backgroundColor: 'aliceblue', borderRadius: '4px', padding: '.5em' }}>
        <Label color='blue'> {_.startCase(key)}{': '}{_count}</Label>
        <List.Content >
          {list_content(false, _data, key)}
        </List.Content>
      </Segment>
    } else {
      return <><strong>{key}:</strong> {value}</>
    }
  }

  // Recursive function to render list items using Lodash
  const renderListItems = (obj, ignoreSc) => {
    return _.map(obj, (value, key) => (
      <List.Item key={key}>
        {listValue(value, key)}
      </List.Item>
    ));
  };

  // Sort data by _name
  const sortedData = (_data) => _.sortBy(
    _.toPairs(_data), // Convert to pairs for key access
    ([key, item]) => item.name || `${item.firstName || ''} ${item.lastName || ''}`.trim() || key
  );

  const header_wrapper = (count) => <div>
    {_.startCase(dataType)}{':'}<Label color='blue' style={{ marginLeft: '2em' }}>{count}</Label>
    <Button
      size="mini"
      floated="right"
      onClick={toggleAll}
      content={isAllExpanded ? 'Hide All' : 'Show All'}
      color='blue'
    />
  </div>

  const grid_header = (isMain, key, _name, item, _dataType) => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div onClick={() => toggleExpand(key)} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
      <Icon name={expandedItems[key] ? 'caret down' : 'caret right'} />
      {_name || key}
    </div>
    <div>
      <Label size='mini' style={{ marginRight: '1em' }}>{isMain ? currentKeys.header : currentKeys.item}</Label>
      {key}
      <Icon name='arrow right' color='blue' style={{ marginLeft: '.5em' }} onClick={(e) => { handleSelect(key, item, isMain ? currentKeys.header : currentKeys.item) }} />
    </div>
  </div>

  const list_content = (isMain, _data, _dataType) => <List divided relaxed className='list-viewer'>
    {_.map(_data, ([key, item]) => {

      if (key === 'undefined') { return }
      // Determine _name based on available props 
      if (!_.isObject(item)) {
        return <List.Item>{_.startCase(key)}{': '}{item}</List.Item>
      }
      const { name, firstName, lastName, parentKeys, latestSeason } = item
      const { sports: sports_pks } = parentKeys ?? {}
      let _name = name || `${firstName || ''} ${lastName || ''}`.trim();
      switch (_dataType) {
        case 'teams':
          if (sports_pks) {
            if (parentData && parentData.sports && parentData.sports[sports_pks]) {
              _name += ' - ' + parentData.sports[sports_pks].name
            } else {
              _name += ' - ' + sports_pks
            }
          }

      }

      if (latestSeason) { _name += ' (' + latestSeason + ')' }

      return (
        <List.Item key={key}>
          {grid_header(isMain, key, _name, item, _dataType)}
          {/* Toggleable content */}
          {expandedItems[key] && (
            <List.List>
              {renderListItems(_.omit(item, ['name', 'firstName', 'lastName', '_itemKey', 'id', 'parentKeys', 'undefined']))}
            </List.List>
          )}
        </List.Item>
      );
    })}
  </List>

  console.log('currentData', currentData)

  const wrapper = () => {
    const _data = currentData ? sortedData(currentData) : {}
    const _count = _.size(_data)
    return <Wrapper
      header={header_wrapper(_count)}
      content={list_content(true, _data, dataType)}
      wrapperType={wrapperTypes.padded}
      css={{ container: 'linking' }}
    />
  }

  return wrapper()
};

export default ListViewer;
